module.exports = __webpack_public_path__ + "./favicons/favicon.ico";